<template>
<div id="container">
    <div class="container_wrap">
        <keep-alive>
    		<dotcom-snb></dotcom-snb>
        </keep-alive>
        <router-view></router-view>
    </div>
</div>
</template>
<script>
import axios       from 'axios';
import SDLUtil     from '@/utils/SDLUtil';

import DotComSnb   from './DotComSnb';

export default {
    name: 'DotCom',
    components: {
    	'dotcom-snb' : DotComSnb
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dotcom/DotCom.vue